import React from 'react';
import LocationHelper from '../../helpers/location_helper';
import FetchHelper from '../../helpers/fetch_helper';

const MockMosaicEsign = () => {
  const { offerId, customerId } = LocationHelper.searchAsObj();
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <button
        style={{
          marginTop: '15px',
          left: '38%',
          width: '25%',
          height: '300px',
          fontSize: 'xxx-large',
        }}
        id={'qa-mock-contract-submitted-button'}
        onClick={async () => {
          await FetchHelper.fetchJson(`customers/${customerId}/mosaic-esign-webhook`, {
            version: '/qa',
            method: 'post',
            body: JSON.stringify({
              offerId,
              type: 'event.offer.ContractSubmitted',
            }),
          });

          window.parent.postMessage({ name: 'mosaic:complete' }, '*');
        }}
      >
        Sign Docs!
      </button>
    </div>
  );
};

export default MockMosaicEsign;
